import React, { useEffect, useState } from 'react'
import _ from 'lodash';
import { useSelector } from 'react-redux';
import * as R from 'ramda';
import { useAppDispatch } from '../../../../../hooks/hooks';
import PageLoader from '../../../../../components/PageLoader';
import { selectMarketingsQueryItems } from '../../../../../redux/marketings/selector';
import { marketings } from '../../../../../redux/marketings/action';
import MarketingComponent from '../components/marketing.component';

const ManagementMarketingsSettings = () => {
  const dispatch = useAppDispatch()
  const marketingSettingsQuery = useSelector(selectMarketingsQueryItems)
  const [isQuery, setIsQuery] = useState<boolean>(false)
  const [isLoading, setIsLoading] = useState<boolean>(true)
  const [selectMarketingSettings, setSelectMarketingSettings] = useState<any>([])

  const fetchMarketingSettingsQueryById = () => {
    dispatch(marketings.query({
      url: `https://api.digiit.${process.env.REACT_APP_API_URL}/api/v4.0/settings/marketing/query`,
      entity: 'marketings',
      jsonData: {
        Records: [
          {
            Id: 0
          }
        ]
      }
    })).then(() => {
      setIsQuery(true)
    })
  }

  const handleInnerFormChange: any = (event: any, field: string, data: any) => {
    const fields = R.split(
      '.',
      field
    );
    const value = { ...data, [fields[1]]: event }// inner data update
    setSelectMarketingSettings({ ...selectMarketingSettings, [fields[0]]: value });
  }

  useEffect(
    () => {
      fetchMarketingSettingsQueryById()
      setIsLoading(false)
    }, []
  )

  useEffect(
    () => {
      if (isQuery) {
        setSelectMarketingSettings(marketingSettingsQuery?.result?.items)
      }
    }, [isQuery]
  )

  const handleFormSubmit = async (event: any) => {
    event.preventDefault();
    await dispatch(marketings.resetAction({ actionType: 'update' }))
    dispatch(marketings.update({
      url: `https://api.digiit.${process.env.REACT_APP_API_URL}/api/v4.0/settings/marketing`,
      entity: 'marketings',
      jsonData: {
        Records: [
          selectMarketingSettings
        ]
      }
    }))
  }

  return (
    <>
      {isLoading ? <PageLoader /> :
        <MarketingComponent
          handleInnerFormChange={handleInnerFormChange}
          selectMarketingSettings={selectMarketingSettings}
          handleFormSubmit={handleFormSubmit}
        />
      }
    </>
  )
};

export default ManagementMarketingsSettings;